<template>
    <div class="card not-word-wrap mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <div class="row" v-if="customerId || $route.params.id">
                <div class="col-12 mb-2" v-if="legalCustomerDetails.companyNameFa">
                    <h5>اطلاعات سازمان</h5>
                    <div class="table-responsive">
                        <table class="table table-bordered table-hover user-details-table">
                            <tbody>
                                    <tr>
                                        <td>نام فارسی:</td>
                                        <td>{{ legalCustomerDetails.companyNameFa }}</td>
                                        <td>نام انگلیسی:</td>
                                        <td>{{ legalCustomerDetails.companyNameEn }}</td>
                                        <td>شناسه ملی:</td>
                                        <td>{{ legalCustomerDetails.nationalId }}</td>
                                    </tr>
                                </tbody>
                        </table>
                    </div>
                </div>
                <div class="col-md-12" v-if="contracts.length">
                    <h5>لیست قرارداد ها</h5>
                </div>
                <div class="col-md-12 mt-2" v-for="(contract,index) in contracts" :key="index">
                    <div :class="`card custom-card card-body contract-item border-1 ${index == 0 ? 'bg-success text-white' : 'border-black-1'}`">
                        <div class="row">
                            <div class="col-md-11">
                                <p class="mb-0">قرارداد از تاریخ <span dir="ltr">{{ contract.persianStartDate }}</span> تا <span dir="ltr">{{ contract.persianExpireDate }}</span></p>
                            </div>
                            <div class="col-md-1">
                                <button class="btn btn-secondary btn-block" @click="downloadContract(index)">دانلود قرارداد</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-4">
                            <label>انتخاب فایل قرارداد</label>
                            <div class="input-group file-browser">
                                <input type="text" class="form-control border-left-0 browse-file" id="contract-file" placeholder="آپلود فایل" readonly="">
                                <label class="input-group-btn mb-0">
                                    <span class="btn btn-primary">
                                        انتخاب کنید <input type="file" style="display: none;" accept=".pdf" @input="setPdfFile">
                                    </span>
                                </label>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <label>تاریخ شروع قرارداد</label>
                            <Datepicker simple auto-submit id="start-date" locale="fa" v-model="fromDate" :locale-config="{
                                fa: {
                                    displayFormat: 'jYYYY/jMM/jDD',
                                    lang: {label: 'شمسی'}
                                }
                            }" />
                        </div>
                        <div class="col-md-4">
                            <label>تاریخ اتمام قرارداد</label>
                            <Datepicker simple auto-submit id="end-date" locale="fa" v-model="toDate" :locale-config="{
                                fa: {
                                    displayFormat: 'jYYYY/jMM/jDD',
                                    lang: {label: 'شمسی'}
                                }
                            }" />
                        </div>
                        <div class="col-md-12 mt-4">
                            <button class="btn btn-success" v-if="file" @click="submit">ثبت درخواست</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-md-3">
                    <form v-on:submit.prevent="searchCustomer">
                        <label for="national-code">شناسه ملی</label>
                        <div class="input-group">
                            <input class="form-control text-left" maxlength="11" id="national-code" type="tel" v-model="nationalCode">
                            <span class="input-group-btn"><button class="btn ripple btn-primary" type="submit"><span class="input-group-btn"><i class="fa fa-search"></i></span></button></span>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Create',
    data(){
        return {
            nationalCode: '',
            legalCustomerDetails: {},
            customerId: 0,
            fromDate: '',
            toDate: '',
            file: '',
            contracts: [],
            organizations: [],
            showLoading: false
        }
    },
    methods: {
        searchCustomer(){
            this.legalCustomerDetails = {};
            const postedData = {
                company: true,
                nationalId: this.nationalCode
            };
            this.showLoading = true;
            this.$api.post('Management/Group/SearchCustomer',postedData).then(({data}) => {
                if(data.status){
                    this.legalCustomerDetails = data.result;
                    this.customerId = data.result.customerId;
                    this.getContracts();
                }
                this.showLoading = false;
            }).finally(() => {
                this.showLoading = false;
            });
        },
        getContracts(){
            this.showLoading = true;
            this.$api.get('Organizations/Bonus/Contracts?OrganizationId=' + this.customerId).then(({data}) => {
                this.contracts = data.result;
            }).finally(() => {
                this.showLoading = false;
            });
        },
        async toBase64(file){
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        async setPdfFile(e){
            const file = e.target.files[0];
            if(file.size > 1000000){
                this.$swal({
                    title: 'خطا',
                    icon: 'error',
                    text: 'حجم فایل قرارداد نمی تواند بیشتر از 1 مگابایت باشد'
                });
                document.getElementById('contract-file').setAttribute('placeholder','انتخاب کنید');
                this.file = '';
            }else{
                const finalFile = await this.toBase64(file);
                this.file = finalFile;
                document.getElementById('contract-file').setAttribute('placeholder',file.name);
            }
        },
        downloadContract(index){
            const contract = this.contracts[index];
            window.open(contract.contractPdf);
        },
        submit(){
            this.showLoading = true;
            const postedData = {
                organizationId: this.customerId,
                persianStartDate: this.fromDate.replace(/\//g,'-'),
                persianExpireDate: this.toDate.replace(/\//g,'-'),
                pdf: this.file
            };
            this.$api.post('Organizations/Bonus/Contracts',postedData).then(({data}) => {
                if(data.status)
                    this.$swal({
                        icon: 'success',
                        title: 'تبریک !',
                        text: 'ثبت قرارداد با موفقیت انجام شد',
                    }).then(res => {
                        if(res.isConfirmed){
                            this.$router.push({name: 'organizations'});
                        }
                    });
            });
        }
    },
    async created(){
        if(this.$route.params.id){
            this.customerId = this.$route.params.id;
            this.showLoading = true;
            await this.$api.post('Management/organizations/List',{perPage: 100,page: 1}).then(({data}) => {
                this.organizations = data.result.list;
            }).finally(() => {
                this.showLoading = false;
            });
            let organization = this.organizations.filter(item => item.domainDataId == this.$route.params.id)[0];
            if(organization){
                this.legalCustomerDetails.companyNameFa = organization.domainMetaData.companyNameFa;
                this.legalCustomerDetails.companyNameEn = organization.domainMetaData.companyNameEn;
                this.legalCustomerDetails.nationalId = organization.domainMetaData.nationalId;
            }
            this.getContracts();
        }
    }
}
</script>
